import styled from "@emotion/styled";
import BasicButton from "@components/button/BasicButton";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { Flex } from "antd";

interface SuccessMessageProps {
  message: string;
  subMessage?: string;
  subMessage2?: string;
  buttonText: string;
  onButtonClick: () => void;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  message,
  subMessage,
  subMessage2,
  buttonText,
  onButtonClick,
}) => {
  const theme = useTheme();
  return (
    <Container>
      <ContentWrapper>
        <Image
          src={theme.image.check_circle.default}
          height="6rem"
          width="6rem"
        />

        <Flex vertical gap={"3rem"}>
          <Message>{message}</Message>

          {subMessage && subMessage2 && (
            <Flex vertical gap={"0.5rem"} align="center">
              {subMessage && <SubMessage>{subMessage}</SubMessage>}
              {subMessage2 && <SubMessage>{subMessage2}</SubMessage>}
            </Flex>
          )}
        </Flex>
      </ContentWrapper>

      <ButtonWrapper>
        <BasicButton
          title={buttonText}
          onClick={onButtonClick}
          width="100%"
          height="5.2rem"
        />
      </ButtonWrapper>
    </Container>
  );
};

export default SuccessMessage;

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "relative",
  height: "calc(100vh - 6rem)",
});

const ButtonWrapper = styled.div({
  position: "absolute",
  bottom: "0",
  left: "0",
  width: "100%",
});

const ContentWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  alignItems: "center",
  marginTop: "22.8rem",
});

const Message = styled.p(({ theme }) => ({
  fontSize: "2.4rem",
  marginTop: "4rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontWeight: theme.fontWeight.medium,
}));

const SubMessage = styled.p({
  fontSize: "1.6rem",
});
